
<template>
  <div>
    <header>
      <Header msg="Header" />
      <SettingsHeader msg="SettingsHeader" />
    </header>
    <main>
      
      <div class="container">
        <div class="editor">
          <div v-html="htmlContent"></div>
        </div>
        
      </div>
      
    </main>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
import Header from "@/components/Header.vue";
import SettingsHeader from "@/components/SettingsHeader.vue";
import apis from "@/services/apis";

export default {
  name: "home",
  data() {
    return {
      htmlContent: ''
    }
  },
  components: {
    SettingsHeader,
    Header
  },
  computed: {
    version() {
      return GLOBAL_ENV_VERSION;
    }
  },
  methods: {
    getContent() {
      return apis.getPortalCsContent(this.$router.currentRoute.query.p)
      .then(response => {
        this.htmlContent = response.content;
      })
    }
  },
  mounted() {
    this.getContent();
  }
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
</style>